import PersianUtil from "@/services/persianUtiles/numberPersianUtiles";
import { InputBase, InputBaseProps } from "@mantine/core";
import { IMaskInput } from "react-imask";

interface Props extends InputBaseProps {
  withThousandsSeparator?: boolean;
  onChangeHandler: (e: string) => void;
  value?: string;
}

const PersianSupportNumberInput = ({
  withThousandsSeparator,
  onChangeHandler,
  value,
  ...props
}: Props) => {
  return (
    <InputBase
      {...props}
      type="tel"
      component={IMaskInput}
      mask={[
        {
          mask: "X",
          blocks: {
            X: {
              mask: Number,
              thousandsSeparator: withThousandsSeparator ? "," : "",
            },
          },
        },
      ]}
      value={value}
      prepare={(e) => PersianUtil.currentNumberToEnglish(e)}
      onAccept={(_, masked) => {
        const unmaskedValue = masked.unmaskedValue.toString();
        onChangeHandler(unmaskedValue);
        return unmaskedValue;
      }}
    />
  );
};

export default PersianSupportNumberInput;
